import { CloseOutlined } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "@mui/material";
import Button from "@mui/material/Button";
import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import { SelectInput, useRefresh } from "react-admin";
import sendRequest from "../dataProvider/sendRequest";
import CustomButtonSubmit from "../unit/CustomButtonSubmit";
import HmTextInput from "../unit/HmTextInput";
import useNotify from "../unit/useNotify";
import formatPhone from "../unit/inputFormat/formatPhone";
import parseNumber from "../unit/inputFormat/parseNumber";
import parsePhone from "../unit/inputFormat/parsePhone";
import validateNumber from "../unit/inputFormat/validateNumber";
import YesNoInput from "../unit/YesNoInput";

const VendorAccountType = ({ ...props }) => {
  const [accountType, setAccountType] = React.useState("savings");
  return (
    <SelectInput
      source="sAccountType"
      variant="outlined"
      label="Account Type"
      value={accountType}
      onChange={(e: any) => {
        setAccountType(e.target.value);
      }}
      choices={[
        { id: "savings", name: "Saving" },
        { id: "checking", name: "Checking" },
      ]}
      required={true}
      helperText={false}
    />
  );
};
const VendorAccountSection = ({ ...props }) => {
  const [showSetting, setShowSetting] = React.useState("No");
  return (
    <>
      <YesNoInput
        source="sSetUpAch"
        label="Set Up ACH Transfer"
        defaultValue={showSetting}
        onChange={(e: any) => {
          if (e.target.value == "Yes") {
            setShowSetting("Yes");
          } else {
            setShowSetting("No");
          }
        }}
        helperText={false}
        sx={{ mt: 0, mb: 0 }}
      />
      {showSetting == "Yes" && (
        <Box>
          <HmTextInput
            source="sInstitutionName"
            label="Bank Name"
            required={true}
          />
          <VendorAccountType source="sAccountType" />
          <HmTextInput
            source="sRoutingNumber"
            label="Routing Number"
            required={true}
          />
          <HmTextInput
            source="sAccountNumber"
            label="Account Number"
            required={true}
          />
        </Box>
      )}
    </>
  );
};
const VendorsAdd = (props: any) => {
  const methods = useForm();
  const refresh = useRefresh();
  const id = 99999;
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  return (
    <>
      <Button
        onClick={handleOpen}
        variant="text"
        color="primary"
        size="small"
        sx={{
          width: "120px",
          minWidth: "120px",
          color: "primary.main",
          "&.MuiButton-sizeSmall": {
            lineHeight: 1.5,
            fontSize: "0.875rem",
          },
        }}
      >
        <AddIcon sx={{ fontSize: "1.25rem" }} /> Vendor
      </Button>
      <FormProvider {...methods}>
        <Dialog
          className="vendors_add_dialog"
          open={open}
          onClose={handleClose}
          fullWidth={true}
          maxWidth="lg"
          PaperProps={{
            component: "form",
            onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              let formJson = Object.fromEntries((formData as any).entries());

              formJson.sContactName =
                formJson.sFirstName + " " + formJson.sLastName;

              console.log("formJson===>", formJson);
              // infoNotify("development in progress");

              const reqUrl = `vendors/actions/add`;
              const response = await sendRequest(reqUrl, {
                id: "new",
                data: formJson,
              });
              // console.log(response.data);
              if (response && response.code == "200") {
                successNotify("Data saved successfully");
                handleClose();
              } else {
                errorNotify(response?.message || "Data not saved!");
              }
            },
          }}
        >
          <DialogTitle
            sx={{
              fontWeight: "bold",
              mb: 2,
              borderBottom: "1px solid #e5e5e5",
              color: "#465384",
              textTransform: "uppercase",
            }}
          >
            Add Vendor
            <IconButton
              style={{ position: "absolute", right: "10px", top: "10px" }}
              onClick={handleClose}
            >
              <CloseOutlined />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box
              sx={{
                width: "100%",
                pt: 1,
                height: "50vh",
                maxHeight: "50vh",
              }}
            >
              <HmTextInput
                source="sName"
                label="Organization Name"
                required={true}
              />
              <HmTextInput
                source="sFirstName"
                label="First Name"
                required={true}
              />
              <HmTextInput
                source="sLastName"
                label="Last Name"
                required={true}
              />

              {/* <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Address Information
            </Typography> */}
              <Grid
                container
                spacing={1}
                sx={{
                  mt: "0px",
                  "& .MuiGrid-item": {
                    pt: 0,
                  },
                }}
              >
                <Grid item xs={8}>
                  <HmTextInput
                    source="sStreet"
                    label="Street"
                    required={true}
                  />
                </Grid>
                <Grid item xs={4}>
                  <HmTextInput
                    source="sStreet2"
                    label="Street2"
                    required={true}
                  />
                </Grid>
                {/* City, State, Zip */}
                <Grid item xs={4}>
                  <HmTextInput source="sCity" label="City" required={true} />
                </Grid>
                <Grid item xs={4}>
                  <HmTextInput source="sState" label="State" required={true} />
                </Grid>
                <Grid item xs={4}>
                  <HmTextInput source="sZip" label="Zip" required={true} />
                </Grid>
              </Grid>
              <HmTextInput
                source="sContactEmail"
                name="sEmail"
                label="Contact Email"
                required={true}
              />
              <HmTextInput
                source="sContactPhone"
                name="sPhone"
                label="Contact Phone"
                required={true}
                format={formatPhone}
                parse={parsePhone}
              />
              <HmTextInput
                source="iMaxLoanAmount"
                label="Set unique maximum loan amount"
                required={true}
                validate={validateNumber}
                parse={parseNumber}
              />
              <HmTextInput
                source="iMaxApplicationFee"
                label="Set unique application fee"
                required={true}
                validate={validateNumber}
                parse={parseNumber}
              />
              <VendorAccountSection />
              {/* <HmTextInput
                source="sWebsite"
                label="Website for Online Purchase"
                required={true}
              /> */}
              {/* <EnabledDisabledInput
              source="sStatus"
              name="sStatus"
              label="Status"
            /> */}
            </Box>
          </DialogContent>
          <DialogActions>
            <CustomButtonSubmit label="Add" />
          </DialogActions>
        </Dialog>
      </FormProvider>
    </>
  );
};

export default VendorsAdd;
